import _ from 'lodash'

function combineClassNames(classNames) {
  return _.join(_.flatMap(_.compact(classNames), _.trim), ' ')
}

export default combineClassNames
